<template>
  <button
    class="btn btn-primary btn-round btn-sm ml-4"
    :disabled="aml_disabled"
    @click="check_aml"
    id="check_aml"
  >
    {{ $t("message.contracts.contract_check_contragent").split(" ")[0] }}
  </button>
</template>
<script>
export default {
  name: "ca-check",
  props: {
    aml_disabled: {
      type: Boolean,
      default: false,
    },
    selected_search_results: {
      type: Array,
      //array of objects: { email, name }
    },
  },
  methods: {
    //makes AML request for the selected company
    check_aml() {
      // if(typeof this.selected_search_results[0] != 'undefined')
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=1")
        .then((response) => {
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.contracts.check_contragent_price_alert") +
                " " +
                response.data.billing_service_price +
                " " +
                response.data.billing_service_cur,
              {
                title: this.$t("message.confirm"),
                size: "md",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                for (var i in this.selected_search_results)
                  window.open(
                    this.$router.options.base +
                      "#/app/aml/" +
                      this.selected_search_results[i].name,
                    "_blank",
                  );
              }
            });
        });
    },
  },
};
</script>
